import { truncateString } from '../../helpers/functions';
import { useTranslation } from 'react-i18next';

export const TickerElement = ({
  name,
  src,
  symbol,
  type,
  exchange,
  currency,
}: {
  name: string;
  src: string;
  symbol: string;
  type?: string;
  exchange?: string;
  currency?: string;
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center w-full h-10">
      <div
        className={`
        flex
        justify-center
        items-center
        w-7
        h-7
        mr-3
        bg-black
        rounded-full
        overflow-hidden
        flex-shrink-0
      `}
      >
        <img className="object-scale-down h-7 w-full" src={src} alt={symbol} />
      </div>

      <div className={'flex overflow-hidden w-full justify-between '}>
        <div className={'w-5/6 flex-col'}>
          <div className={'overflow-hidden uppercase font-medium'}>
            {symbol || truncateString(name, 8)}
          </div>
          <div className={'text-sm text-grey-70'}>
            {truncateString(name, 20)}
            {exchange && <span className="uppercase"> ({exchange})</span>}
          </div>
        </div>
        <div className={'w-1/6 text-sm flex justify-end items-center'}>
          {type && (
            <span className={'text-grey-70'}>{t(`assetType.${type}`)}</span>
          )}
          <span className={'ml-2 uppercase font-medium'}>
            {type === 'FOREX' ? symbol : currency}
          </span>
        </div>
      </div>
    </div>
  );
};
